import { ChainId_Internal } from '../types';
export const ROUTER_SC_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: '0x4E792B8c9bcB9E200C3713810C4D6eA8C4230E7c',
    [ChainId_Internal.ZK_EVM_TEST]: '0x9EB4db2E31259444c5C2123bec8B17a510C4c72B',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: '0x66C0893E38B2a52E1Dc442b2dE75B802CcA49566',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: '0xC74C960708f043E04a84038c6D1136EA7Fcb16a1',
    [ChainId_Internal.ETHEREUM]: '0xF15133D086a2Cf2a8a6FFA730Fb02C8421Eecc92',
    [ChainId_Internal.SEPOLIA]: '0x0eAE346f57961Fc2aa055aE7403F422793e3fc28',
};
export const ADDRESS_THIS_BY_CHAIN = {
    [ChainId_Internal.ZK_EVM]: '0x0000000000000000000000000000000000000002',
    [ChainId_Internal.ZK_EVM_TEST]: '0x0000000000000000000000000000000000000002',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: '0x0000000000000000000000000000000000000002',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: '0x0000000000000000000000000000000000000002',
    [ChainId_Internal.ETHEREUM]: '0x0000000000000000000000000000000000000002',
    [ChainId_Internal.SEPOLIA]: '0x0000000000000000000000000000000000000002',
};
